import React from "react";

import { useRouterSearchParams } from "@/hooks/router";
import EventDetailsScreen from "@/screens/Content/Details/ContentDetailsScreen";

function Screen(): React.JSX.Element {
  const eventId = useRouterSearchParams("eventId", "1");
  return <EventDetailsScreen eventId={eventId} />;
}

export default Screen;
